<template>
  <div class="followupDetail">
    <div class="nav">
      <div class="title">
        <i class="iconfont icon-yuyue"></i>
        <p>随访计划/结果</p>
      </div>
      <div class="line"></div>
      <div class="main">

        <div class="top-nav">
          <div
            v-for="(item,index) in tags"
            :key="index" 
            class="option-item"
            @click="activeOption(item.text,index)"
            v-bind:style="{'backgroundColor': item.checked ? item.activecolor : '','color': item.checked ? item.color : '','font-weight': item.checked ? 'bolder': '','font-size': item.checked ? '20px': ''}"
          >
            <span>{{item.text}}({{itemNums[index]}})</span>
          </div>
        </div>

        <!-- 显示随访结果 -->
        <div class="fotter" v-if="isResultActive">
          <div style="height:92%">
            <div class="list-hid" v-if="followupResult.length>0">
              <div ref="mySwiper" class="firstShow">
                <div
                  v-for="(ele,index2) in followupResult"
                  :key="index2"
                  class="check-box"
                  :style="{'background':'#fff3cd'}"
                >
                  <div
                    @click="getFollowupResultDetail(ele.id)"
                    class="check-box2"
                  >
                    <div class="check-info">
                      <p style="display: flex;justify-content: space-between">
                        <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                          时间:
                          <span>{{ele.create_time}}</span>
                        </span>
                      </p>
                      <p style="display: flex;justify-content: space-between">
                        <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                          模板:
                          <span>{{ele.template_name}}</span>
                        </span>
                      </p>                  
                      <p style="display: flex;justify-content: space-between">
                        <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                          PASI评分:
                          <span>{{ele.template_data.score}}</span>
                        </span>
                      </p>
                      <p style="display: flex;justify-content: space-between">
                        <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                          备注:
                          <span>{{ele.note}}</span>
                        </span>
                      </p>
                      <p style="display: flex;justify-content: space-between">
                        <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                          来自:
                          <span>{{ele.from}}</span>
                        </span>
                      </p>
                      <div
                        class="iconfont modify-btn"
                        style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold; text-align: right"
                        title="修改"
                        @click.stop="showModifyFollowupResult(ele.id,index2)"
                      >&#xe630e;</div>

                      <!-- <p class="ellipsisP">
                        检查部位:
                        <span class="ellipsisSpan ellipsis">{{ele.position_detail_list}}</span>
                      </p>
                      <template v-if="ele.doctor_conclusion">
                        <div
                          style="display: flex;align-items: flex-end;justify-content: space-between"
                        >
                          <p class="ellipsisP">
                            检查结果:
                            <span
                              class="ellipsis ellipsisSpan"
                            >{{ele.doctor_conclusion | formatConclusion}}</span>
                          </p>
                          <div
                            class="iconfont modify-btn"
                            style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                            title="编辑诊断"
                            v-acl="['diagnoses_image']"
                            @click.stop="modifyDiagnosis(ele.id)"
                            v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                          >&#xe630e;</div>
                          <div
                            class="iconfont"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                            title="不可编辑"
                            v-else
                            @click.stop
                          >&#xe630e;</div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          style="display: flex;align-items: flex-end;justify-content: space-between"
                        >
                          <p>
                            检查结果:
                            <span></span>
                          </p>
                          <div
                            v-acl="['diagnoses_image']"
                            class="iconfont modify-btn"
                            style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                            title="编辑诊断"
                            @click.stop="modifyDiagnosis(ele.id)"
                            v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                          >&#xe630e;</div>
                          <div
                            class="iconfont"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                            title="不可编辑"
                            v-else
                            @click.stop
                          >&#xe630e;</div>
                        </div>
                      </template> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>  
          </div>
          <div style="display:flex; align-items:center; justify-content:flex-end">
            <button
              class="btn iconfont leftItemSubmit"
              @click.prevent="showAddFollowupResult"
              style="padding: 0;margin-right: 8px"
            >添加随访记录</button>
          </div>

        </div>

        <!-- 对话框：添加或者编辑随访结果 -->
        <div class="resetFollowup">
          <el-dialog
            title="随访记录编辑"
            class="dialog"
            :visible.sync="isShowEditFollowupResult"
            width="900px"
            :close-on-click-modal="false"
            @close="closeAddFollowupResult"
          >
            <div class="navBorder"></div>
            <div id="modifyFollowupPatient">
              <el-form :model="followupResultForm"  inline>
                <el-col :span="24">
                    <p class="rightItemTitle popTitleDialog">银屑病 PASI 评分：&nbsp;&nbsp; {{totalPASIScore}} &nbsp;分</p>
                </el-col>          
                <el-col :span="24">
                  <div class="line lineGray"></div>
                </el-col>
              </el-form>

              <div class="top-nav">
                <div
                  v-for="(item,index) in PASITableTags"
                  :key="index" 
                  class="option-item"
                  @click="activeOption4PASI(item.text,index)"
                  v-bind:style="{'backgroundColor': item.checked ? item.activecolor : '','color': item.checked ? item.color : '','font-weight': item.checked ? 'bolder': '','font-size': item.checked ? '20px': ''}"
                >
                  <span>{{item.text}}</span>
                </div>
              </div>

            </div>

            <!-- 表单生成器  测试-->
            <div>
              <fm-generate-form 
                :data="formJsonData" 
                :value="currentPASIPosData"
                @on-change="PASIFormOnChange"
                ref="generateForm"
              >
              </fm-generate-form>

              <el-form ref="form2" inline>
                <el-col :span="12" :offset="12">
                  <button
                    class="btn iconfont leftItemSubmit2"
                    @click.prevent="addFollowupResult"
                    style="padding: 0"
                    v-if="isShowAddFollowupResult"
                  >添加</button>
                  <button
                    class="btn iconfont leftItemSubmit2"
                    @click.prevent="modifyFollowupResult"
                    style="padding: 0"
                    v-else           
                  >保存</button>
                </el-col>
              </el-form>
            </div>
          </el-dialog>
        </div>


        <!-- 显示随访计划 -->
        <div class="fotter" v-if="isPlanActive" >
          <template>
            <el-table :data="followupPlan" stripe style="width:100%; height:90%" 
            @select-all="selectchageall"
            @cell-dblclick="dbclickCell">

              <!-- <el-table-column type="selection" align="center" width="50">
                  <template v-slot="scope">
                      <el-checkbox v-model="scope.row.checked" 
                          @change="handleCheckChange(scope.row)"></el-checkbox>
                  </template>
              </el-table-column> -->

              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column
                v-for="(item,index) in planTableTitle"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
              ></el-table-column>

              <el-table-column label="操作" width="100%-1150">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column label="" >
                <template slot-scope="scope">
                  <el-button
                    @click.stop="showRevise(scope.$index,scope.row)"
                    size="mini"
                    type="primary"
                    icon="el-icon-edit"
                    style="width: 50px;display:inline-block;"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="this.pageNumber"
                    :page-size="this.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="this.pageTotal">
            </el-pagination>
          </template>
        </div>

        <!-- 显示随访模板 -->
        <div class="fotter" v-if="isTemplateActive">
          <p>暂无随访模板</p>
        </div>

        <!-- 编辑随访计划 -->

        <iframe hidden ref="iframePDF"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
import followupTemplate from "../gql/getFollowupTemplate.gql";
import followupResultPASI from "./followupResultPASI.vue";

let regData = /[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
export default {
  name: "followupDetail",
  components: {
    followupResultPASI
  },
  data() {
    return {

      planTableTitle: [
        { prop: "state", label: "进行状态", width: "100" },
        { prop: "descripition", label: "描述", width: "100" },
        { prop: "create_time", label: "添加时间", width: "100" },
        { prop: "template_name", label: "模板", width: "100" },
        { prop: "channel", label: "发送渠道", width: "150" },
        { prop: "send_datetime1", label: "发送时间1", width: "100" },
        { prop: "send_datetime2", label: "发送时间2", width: "100" },
        { prop: "send_datetime3", label: "发送时间3", width: "100" },
        { prop: "send_datetime4", label: "发送时间4", width: "100" },
        { prop: "task_num", label: "子任务数量", width: "100" },
        { prop: "complete_num", label: "完成数量", width: "100" },
        { prop: "last_feedback_datetime", label: "最近结果时间", width: "100" },       
        
      ],

      // 随访计划
      followupPlan:[],
      // 随访结果
      followupResult:[],
      // 随访模板
      followupTemplate:[],

      // itemNums:[0,0,0],

      doctor_id: -1,
      // followupList.vue 中，双击选中的followup_patient.id
      followupElectiveId:-1,

      pageSize: 6,
      pageTotal:0,
      pageNumber: 1,

      // 可选标签
      tags: [
        {
          text: "随访结果",
          text2: "edit_RES",
          checked: false,
          activecolor: "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        },
        {
          text: "随访计划",
          text2: "edit_PLAN",
          checked: false,
          activecolor:  "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        },
        {
          text: "随访模板",
          text2: "edit_TEMPLATE",
          checked: false,
          activecolor:  "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        }
      ],
      
      // Tab标签是否被选择
      isResultActive: false,
      isPlanActive: false,
      isTemplateActive: false,      
     
      // 是否显示随访计划、随访结果编辑窗口
      isEditPlan:false,
      isEditResult:false,

      // 是否显示随访结果添加窗口
      isShowAddFollowupResult: false,
      // 是否显示随访结果编辑窗口
      isShowModifyFollowupResult: false,
      // 当前待编辑的随访随访结果 ID
      currentFollowupResultId: '',
      // 用于随访患者信息编辑时，暂存信息
      followupResultForm: {
        followupTemplateId:-1,
        followupTemplateName: '',
        followupId:-1,
      },

      // 是否显示随访计划添加窗口
      isShowAddFollowupPlan: false,
      // 是否显示随访计划编辑窗口
      isShowModifyFollowupPlan: false,
      // 当前待编辑的随访随访计划ID
      currentFollowupPlanId: '',

      // 用于随访患者信息编辑时，暂存信息
      followupPlanForm: {
        followupId:-1,
        group_name: "",
        note: ""
      },

      // PASI 表单 可选标签
      PASITableTags:[{
          text: "头颈部",
          checked: false,
          activecolor: "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        },
        {
          text: "上肢",
          checked: false,
          activecolor:  "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        },
        {
          text: "躯干",
          checked: false,
          activecolor:  "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        },
        {
          text: "下肢",
          checked: false,
          activecolor:  "#ffffff", // "#eff3f7",
          color: "#61a2bf"
        }
      ],
      // PASI 评分表单设计
      formJsonData:{"list":[{"type":"radio","icon":"icon-radio-active","options":{"inline":false,"defaultValue":"50%-69%。","showLabel":false,"options":[{"value":"0","label":"Option 1"},{"value":"1%-9%","label":"Option 2"},{"value":"10%-29%","label":"Option 3"},{"value":"30%-49%"},{"value":"50%-69%"},{"value":"70%-89%"},{"value":"90%-100%"}],"required":false,"width":"30%","remote":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1703142375000_38165","disabled":false},"name":"皮损面积","key":"1703142375000_38165","model":"a","rules":[]},{"type":"radio","icon":"icon-radio-active","options":{"inline":false,"defaultValue":"","showLabel":false,"options":[{"value":"0. 无红斑","label":"Option 1"},{"value":"1. 微弱红斑","label":"Option 2"},{"value":"2. 淡红色红斑","label":"Option 3"},{"value":"3. 中度红色红斑"},{"value":"4. 亮红色红斑"}],"required":false,"width":"","remote":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1703142641000_29546","disabled":false},"name":"红斑严重程度(E)","key":"1703142641000_29546","model":"e","rules":[]},{"type":"radio","icon":"icon-radio-active","options":{"inline":false,"defaultValue":"Option 1","showLabel":false,"options":[{"value":"0. 无斑块突出","label":"Option 1"},{"value":"1. 最小斑块升高，几乎不明显","label":"Option 2"},{"value":"2. 轻度板块升高，轻微但明确升高","label":"Option 3"},{"value":"3. 中度斑块升高，伴有清晰边缘升高，约0.75mm"},{"value":"4. 严重斑块升高，尖锐的边缘升高，>1mm"}],"required":false,"width":"80%","remote":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1703142805000_74526","disabled":false},"name":"浸润严重程度(I)","key":"1703142805000_74526","model":"i","rules":[]},{"type":"radio","icon":"icon-radio-active","options":{"inline":false,"defaultValue":"New Option","showLabel":false,"options":[{"value":"0. 无鳞屑","label":"Option 1"},{"value":"1. 最小，偶尔有细小鳞屑","label":"Option 2"},{"value":"2. 轻度，主要是细小鳞屑","label":"Option 3"},{"value":"3. 中度，主要是大块鳞屑"},{"value":"4. 重度，主要是厚块鳞屑"}],"required":false,"width":"","remote":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1703143048000_20592","disabled":false},"name":"鳞屑（S）","key":"1703143048000_20592","model":"d","rules":[]}],"config":{"labelWidth":100,"labelPosition":"left","size":"medium"}},
      currentPASIPosIndex: 0,
      totalPASIScore: 0,
      currentPASIPosData: { "a": "", "e": "", "i": "", "d": "" },
      PSAIData:[
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" }
      ]

    };
  },
  mixins: [],
  created() {
    this.doctor_id = this.$store.state.doctorDitail.id;
    console.log("In followupDetail.created, this.doctor_id:", this.doctor_id);

  },
  computed: {    
    itemNums() {
      return [this.followupResult.length, this.followupPlan.length, this.followupTemplate.length];

    },
    patient_id() {
      return this.$store.state.cosmetRegistrationPatientId;
    },
    opearClick() {
      return this.$store.state.followupClearClick;
    },
    editObjId() {
      return this.$store.state.editcosmetRegistrationObjId;
    },
    operationElectiveId() {
      return Number(this.$store.state.cosmetRegistrationElectiveId);
    },
    isShowEditFollowupResult(){
      return this.isShowAddFollowupResult || this.isShowModifyFollowupResult;
    },
    isShowEditFollowupPlan(){
      return this.isShowAddFollowupPlan || this.isShowModifyFollowupPlan;
    },


  },
  mounted() {
    if (this.opearClick) {
      this.isResultActive = true;
      this.isPlanActive = false;
      this.isTemplateActive = false;
      this.restore();
      // this.reset();
    } else{
      this.reset();
    }
    // this.getcosmetRegistrationLeft()
  },
  watch: {

    'opearClick'(newVal) {
      console.log("In watch opearClick, value:",newVal);

      if (newVal) {
        this.restore();
      }
    },

  },
  methods: {
    // async handleSubmitForm () {
    //   this.$refs.generateForm.getData().then(data => {
    //     alert(JSON.stringify(data))
    //   }).catch(e => {
    //   })
    // },
    getTotalPASIScore(){
      let areaRatio = [0.1,0.2,0.3,0.4];
      let areaMap = {"0":0, "1%-9%":0.1,"10%-29%":0.2,"30%-49%":0.4,"50%-69%":0.6, "70%-89%":0.8,"90%-100%":0.9};
      let score = 0;        
      for(let i=0; i<this.PSAIData.length;i++){
          score += areaRatio[i] * areaMap[this.PSAIData[i].a] * ( this.extractPASIInt(this.PSAIData[i].e) + this.extractPASIInt(this.PSAIData[i].i) + this.extractPASIInt(this.PSAIData[i].d));
      }
      console.log("PASI total score:",score);
      return score;
    },

    extractPASIInt(str){
      return parseInt(str[0]);
    },

    // 获取 PASI 表单数据 
    async PASIFormOnChange(field, value) {
      if (field == 'a') {
        this.currentPASIPosData.a = value;
      }
      if (field == 'e') {
        this.currentPASIPosData.e = value;
      }
      if (field == 'i') {
        this.currentPASIPosData.i = value;
      }
      if (field == 'd') {
        this.currentPASIPosData.d = value;
      }
      // console.log("In PASIFormOnChange, change field value:",field, value);
      this.PSAIData[this.currentPASIPosIndex] = this.currentPASIPosData;
      console.log("In PASIFormOnChange:",this.PSAIData);
      this.totalPASIScore =  this.getTotalPASIScore();
      if(this.totalPASIScore){
        this.totalPASIScore = this.totalPASIScore.toFixed(2);
      }else{
        this.totalPASIScore = 0;
      }      
    },


    // 激活PASITable tag
    activeOption4PASI(param,index){
      console.log("activeOption4PASI, index:",index);
      this.currentPASIPosIndex = index;
      this.currentPASIPosData = this.PSAIData[this.currentPASIPosIndex];

      let i = 0;
      for(let item of this.PASITableTags){
        if(i===index){
          item.checked = true;
        }else{
          item.checked = false;
        }
        i += 1;
      }

    },

    async handleCurrentChange(val) {
      this.pageNumber = val;
      // await this.getList();
      //await this.getPatientsDiagnoses();
    },
    // 激活tag
    activeOption(param, index) {
      console.log("activeOption, index:",index);
      // this.tags[index].checked = true;
      switch (index) {  
        case 0:
          this.isResultActive = true;
          this.isPlanActive = false;
          this.isTemplateActive = false;
          break;              
        case 1:
          this.isResultActive = false;
          this.isPlanActive = true;
          this.isTemplateActive = false;
          break;  
        case 2:
          this.isResultActive = false;
          this.isPlanActive = false;
          this.isTemplateActive = true;
          break;                 
      }

      for (let i = 0, len = this.tags.length; i < len; i++) {
        if (this.tags[i].text === param && i === index) {
          this.$set(this.tags[i], "checked", true);
        } else {
          if (this.tags[i].checked) {
            // this.tags[i].checked = false;
            this.$set(this.tags[i], "checked", false);
          }
        }
      }
    },
    
    // 根据Followup List 传递过来的Plan 和 result 参数，显示信息
    async restore(){
      console.log("In followupDetail, restore, store.state.followupInfo:",this.$store.state.followupInfo);
        if(this.$store.state.followupInfo){          
          this.followupPlan = this.$store.state.followupInfo.followupPlan;
          this.followupResult = this.$store.state.followupInfo.followupResult;
        }
        if(this.$store.state.followupElectiveId){
          this.followupElectiveId = this.$store.state.followupElectiveId;
        }
        
        // 获取模板信息
        let queryObj = {
          doctor_id: this.doctor_id,
        }
        let tmp_res = await this.$apollo.query({
            query: followupTemplate,
            variables: queryObj,
            fetchPolicy: "no-cache"
        });
        if(tmp_res!==null && tmp_res!==undefined && tmp_res.length>0){
          this.followupTemplate = tmp_res;
        }

        this.$store.commit("setfollowupClearClick", false);
        console.log("In followupDetail, restore,this.followupPlan:",this.followupPlan);
        console.log("In followupDetail, restore,this.followupResult:",this.followupResult);

        this.activeOption("随访结果", 0);
        
    },
    
    // 置空数据
    async reset() {
      console.log("In followupDetail,reset.");
      //重置组件变量为default
      this.followupPlan = [];
      this.followupResult = [];
      this.followupTemplate = [];
      this.isPlanActive = false;
      this.isResultActive = true;
      this.isTemplateActive = false;
      this.followupElectiveId = -1;
      this.activeOption("随访结果", 0);
      // this.$store.commit("setcosmetRegistrationFormElectiveStatus", true);
    },

    // 刷新数据
    async refresh() {
      console.log("In followupDetail,refresh.");
      if(this.followupElectiveId!==-1){
        let queryObj = {
          id: this.followupElectiveId,
          page_size: this.pageSize,
          page_number: this.pageNumber,
        };
        console.log("In refresh, queryObj:",queryObj);
        let res = await this.$apollo.query({
          query: getFollowupList,
          variables: queryObj,
          fetchPolicy: "no-cache"
        });
        console.log("In refresh, get data, res:",res);
        let newData = res.data.followupinfo.data;
        this.pageTotal = res.data.followupinfo.count;
        if(newData!==null && newData!==undefined && newData.length>0){
          this.followupPlan = newData[0].followup_plan;
          this.followupResult = newData[0].followup_result;
        }else{
          // console.log("")
        }
        // console.log("In getList, item Total:",this.pageTotal);      
      }else{
        console.log(" ERROR: In followupDetail,refresh,followupElectiveId:",this.followupElectiveId);
      }
    },

    async modifyFollowupResult(id){

    },

    // 打开随访结果 添加 对话框（共用同一个对话框）
    showAddFollowupResult(){
      this.isShowAddFollowupResult = true;
      this.isShowModifyFollowupResult = false;      
      
      this.totalPASIScore = 0;
      this.currentPASIPosData = { "a": "", "e": "", "i": "", "d": "" };
      this.PSAIData = [
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" },
        { "a": "0", "e": "0", "i": "0", "d": "0" }
      ]    
      this.activeOption4PASI('',0);   

    },

    // 打开随访结果 编辑 对话框 （共用同一个对话框）
    showModifyFollowupResult(id,index){
      this.isShowAddFollowupResult = false;
      this.isShowModifyFollowupResult = true;
      this.currentFollowupResultId = id;
      
      console.log("In showModifyFollowupResult,this.followupResult[index].template_data:",index,this.followupResult[index].template_data);
      for(const [key, value] of Object.entries(this.followupResult[index].template_data)){
        // template_data is like {'a1':N, 'e1':, 'i1':, 'd1':, 'a2':N, 'e2':, 'i2':, 'd2':,}
        if(key.length === 2 && key!=='id'){
          console.log(key,value);
          this.PSAIData[parseInt(key[1])-1][key[0]] = value;
        }
      }
      console.log("In showModifyFollowupResult, load FollowupResult, data :", this.PSAIData);
      this.totalPASIScore = this.followupResult[index].template_data.score;   
      this.activeOption4PASI('',0);  

    },

    // 增加 随访结果
    addFollowupResult() {
      console.log("addFollowupResult");      
    },
    // 修改 随访结果
    modifyFollowupResult() {
      console.log("modifyFollowupResult");      
    },
    // 关闭 随访结果 编辑对话
    closeAddFollowupResult() {
      this.isShowAddFollowupResult = false;
      this.isShowModifyFollowupResult = false;
    },


    // 打开随访计划 添加 对话框（共用同一个对话框）
    showAddFollowupPlan(){
      this.isShowAddFollowupPlan = true;
      this.isShowModifyFollowupPlan = false;
    },
    // 打开随访计划 编辑 对话框 （共用同一个对话框）
    showModifyFollowupPlan(){
      this.isShowAddFollowupPlan = false;
      this.isShowModifyFollowupPlan = true;
    },
    // 增加 随访计划
    addFollowupPlan() {
      console.log("addFollowupPlan");      
    },
    // 修改 随访计划
    modifyFollowupPlan() {
      console.log("modifyFollowupPlan");      
    },
    // 关闭 随访计划 编辑对话
    closeAddFollowupPlan() {
      this.isShowAddFollowupPlan = false;
      this.isShowModifyFollowupPlan = false;
    },

    // 根据 operationElectiveId 获取后台相应登记数据，并赋值给组件变量
    // async getCosmetRegistration() {
    //   try {
    //     let res = await this.$apollo.query({
    //       query: getCosmetRegistrationData,
    //       variables: {
    //         id: this.operationElectiveId
    //       },
    //       fetchPolicy: "no-cache"
    //     });
    //     let newData = res.data.cosmetRegistration;
        
    //     // if (newData.operation_position) {
    //     //   let newArray1 = newData.operation_position.split(",");
    //     //   let newObj = [];
    //     //   for (let i = 0; i < newArray1.length; i++) {
    //     //     newObj.push(newArray1[i].split("-"));
    //     //   }
    //     //   this.cosmetRegistration = newData;
    //     //   this.$set(this.cosmetRegistration, "operation_position_new", newObj);
    //     // } else {
    //     //   this.cosmetRegistration = newData;
    //     //   this.$set(this.cosmetRegistration, "operation_position_new", "");
    //     // }
    //     this.cosmetRegistration = newData;
    //     // 数据库内的字段是 "operation_position" , 前端代码内的字段是 "operation_position_new"
    //     this.$set(this.cosmetRegistration, "operation_position_new", newData.operation_position);

    //     this.$set(
    //       this.cosmetRegistration,
    //       "operation_fee",
    //       `${newData.operation_fee * 0.01}`
    //     );
    //     this.resetOperationDate = moment(newData.operation_date).format(
    //       "YYYY-MM-DD"
    //     );

    //     //console.log("In ElectiveCosmetRegister, getCosmetRegistration:",this.cosmetRegistration);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // 新增或者修改登记；必选项：operation_name，operation_date，am_pm
    // async addCosmetRegistration() {
    //   //console.log("In addCosmetRegistration，operation_name：",this.cosmetRegistration.operation_name," patient_id:",this.patient_id, " operationRelevantId:",this.operationRelevantId, "operationElectiveId:",this.operationElectiveId);
    //   console.log("In addCosmetRegistration, cosmetRegistration:",this.cosmetRegistration);
    //   if (this.cosmetRegistration.operation_name){
    //     if (this.patient_id && this.operationRelevantId) {
    //       if (this.cosmetRegistration.operation_date && this.cosmetRegistration.am_pm) {
    //         let isbofore = moment(this.cosmetRegistration.operation_date).isAfter(
    //           moment().add(-1, "days")
    //         );

    //         if (!isbofore) {
    //           if (this.operationElectiveId) {
    //             this.hasMutate = true;
    //             await this.setCosmetRegistration();
    //           } else {
    //             this.$message.error("无法预约过去时间");
    //           }
    //         } else {
    //           this.hasMutate = true;
    //           //存在ID，修改已有登记
    //           if (this.operationElectiveId) {
    //             //console.log("modify CosmetRegistration, operationElectiveId:",this.operationElectiveId)
    //             await this.setCosmetRegistration();
    //           } else {
    //             //新增登记
    //             //console.log("add new CosmetRegistration, operationElectiveId:",this.operationElectiveId)
    //             await this.mutateCosmetRegistration();
    //           }
    //         }
    //       } else {
    //         this.$message.error("请先选择预约日期及时段");
    //       }
    //     } else {        
    //       this.$message.error("请先添加患者信息和相关信息");
    //     }
    //   } else {
    //     this.$message.error("请先输入治疗项目");
    //   }
    // },

    async getMe() {
      try {
        let res = await this.$apollo.query({
          query: gql`
            {
              me {
                id
                realname
              }
            }
          `
        });
        let realname = res.data.me.realname;
        this.$store.commit("setMe", realname);
        localStorage.setItem("me", realname);
        this.$store.commit("setdoctorDitail", {
          id: res.data.me.id,
          realname: res.data.me.realname ? res.data.me.realname : ""
        });
      } catch (error) {
        this.$message.error("请检查网络后重试");
      }
    }
  }
};
</script>
<style lang="less">

.top-nav {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  // flex-shrink: 2;
  width: 100%;
  /*height: 8.6%;*/
  height: 36px;
  display: flex;
  
  .option-item {
    background: #e0dede;
    // margin: 0px 1px 0px 0px;
    width: 300px;
    flex: 1;
    height: 100%;
    font-size: 16px;
    text-align: center;
    // box-shadow: 2px 2px 2px grey;
    white-space: nowrap;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px 0px 6px 6px;
  }
  
  .option-item:nth-child(3) {
    margin-bottom: 0px;
  }
}

.fotter {
  width: 100%;
  height: 240px;
  justify-content: center !important;
  align-items: center;
  .pageFen {
    display: flex;
    justify-content: center !important;
    height: 180px;
    line-height: 37px !important;
    padding-top: 10px;
  }
}

.el-pagination {
  height: 34px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-next,
  .btn-prev {
    line-height: 38px !important;
  }
}

.followupDetail {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }
  .el-select,
  .el-cascader,
  .el-form-item__content {
    width: 100%;
  }
  .el-form-item {
    width: 100% !important;
    display: flex;
    margin-top: 10px;
    padding-left: 24px;
    box-sizing: border-box;
    margin-bottom: 0;
  }
  .el-form-item__content {
    flex: 1;
  }
  .el-input input {
    // min-height: 36px !important;
    height: 36px !important;
    width: 100%;
  }
  .el-cascader__tags {
    height: 32px !important;
    overflow-y: auto;
    padding-top: 2px;
    // margin: 1px 0 !important;
    box-sizing: border-box !important;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>
<style lang="less">
.followupDetail {
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }
  .nav {
    .title {
      display: flex;
      color: #4ea3c0;
      // height: 40px;
      line-height: 45px;
      i {
        // text-indent: 50px;
        font-size: 30px;
      }
      p {
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }
  .main {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .leftItemSubmit {
      height: 40px;
    }
    .btnBottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding-left: 24px;
      box-sizing: border-box;
    }
  }
  .hasDIsabled {
    background: gray !important;
    cursor: not-allowed;
  }
  .popInput {
    width: 100%;
  }
  .operation_date{
    position: relative;
    .now_operation{
      position: absolute;
      right: 30px;
      background: #67c23a;
      color: white;
      border-radius: 4px;
      padding: 0 4px;
    }
  }
}

.firstShow {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.check-box {
  cursor: pointer;
  width: 15%;
  // min-width: 412px;
  height: 100%;
  background: #ebebeb;
  border-radius: 15px;
  box-shadow: 5px 5px 5px #888888;
  float: left;
  margin: 10px 1.16%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;

  .imgBack {
    width: 155px;
    height: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check-info {
    span {
      color: black;
    }
  }
}

.check-box .check-info {
  margin-left: 5%;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.check-info p {
  color: #4aa3c4;
  margin-bottom: 12px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
}

.check-box2 {
  width: 100%;
  display: flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ellipsisP {
  flex: 1;
  display: flex;
  .ellipsisSpan {
    flex: 1;
    width: 1px;
    text-align: left;
  }
}
.modify-btn{
  align-content: center;
  align-items: center;
}
.modify-btn:hover{
  color: #ff7979 !important;
}

.dialog {
  // min-width: 1205px;
  display: flex;
  align-items: center;
  .navBorder {
    width: 100%;
    height: 2px;
    background: #4da3c0;
  }
  .popTitleDialog {
    font-size: 12px;
    // font-weight: 80;
    color: black;
    margin-bottom: 10px;
    margin-top: 10px;
    // text-indent: 12px;
  }
  .popInput {
    // width: 200px;
    // border: 1px solid #c0c0c0 !important;
    border-radius: 8px;
    // height: 30px;
    // box-sizing: border-box;
    margin: 0 10;
    // background: red;
  }
  .popInputSingle2 {
    width: 630px !important;
  }
  .leftItemSubmit2 {
    width: 298px;
    height: 42px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .isBW {
    display: flex;

    .isBWItem {
      flex: 1;
      font-size: 20px !important;
      font-weight: 600;
    }
    .activeBW {
      background: white;
      color: black;
    }
  }
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }

  .lineGray {
    background: #b8b8b8;
  }
}


</style>
